import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./document-tree-view.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./document-tree-view.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
let DocumentTreeViewComponent = class DocumentTreeViewComponent {
    nodes = [];
    displayField;
    descriptionField;
    downloadField;
    columns = [];
    options = {
        useVirtualScroll: false,
        nodeHeight: 30,
        isExpandedField: "expanded"
    };
    constructor() { }
    ngOnInit() {
        this.columns = [this.descriptionField, this.downloadField];
        this.options.displayField = this.displayField;
    }
    static ctorParameters = () => [];
    static propDecorators = {
        nodes: [{ type: Input }],
        displayField: [{ type: Input }],
        descriptionField: [{ type: Input }],
        downloadField: [{ type: Input }]
    };
};
DocumentTreeViewComponent = __decorate([
    Component({
        selector: "app-document-tree-view",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], DocumentTreeViewComponent);
export { DocumentTreeViewComponent };
